var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDecrease16To30(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 38,
    viewBox: "0 0 46 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.5521 28.6124C44.988 28.0967 44.1125 28.1383 43.5968 28.7023L39.9978 32.644V7.24307C39.9978 6.28794 39.2226 5.51276 38.2675 5.51276H19.3068C18.3516 5.51276 17.5765 6.28794 17.5765 7.24307V18.189H3.46062V1.73031C3.46062 0.775178 2.68544 0 1.73031 0C0.775178 0 0 0.775178 0 1.73031V19.9193C0 20.8744 0.775178 21.6496 1.73031 21.6496H19.3068C20.2619 21.6496 21.0371 20.8744 21.0371 19.9193V8.97338H36.5406V32.9208L32.2599 28.8546C31.7062 28.3286 30.8306 28.3494 30.3011 28.9031C29.7751 29.4568 29.7959 30.3323 30.3496 30.8583L36.686 36.8798C36.9559 37.4888 37.5615 37.911 38.2675 37.911C38.2813 37.911 38.2917 37.911 38.3021 37.9076C38.309 37.9076 38.3159 37.9076 38.3229 37.9076C38.4163 37.9076 38.5097 37.8972 38.5997 37.8799C38.6274 37.873 38.6551 37.8626 38.6828 37.8557C38.7451 37.8384 38.8073 37.8245 38.8662 37.7968C39.278 37.6446 39.6137 37.34 39.8075 36.949L45.6386 30.5642C46.1542 30.0001 46.1127 29.1245 45.5486 28.6089L45.5521 28.6124Z",
    fill: "#24C062"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecrease16To30);
export default __webpack_public_path__ + "static/media/decrease16to30.2e7e7e700a4f2e7a3d8b19c5660001f6.svg";
export { ForwardRef as ReactComponent };